export default {
  customAudiences: [],
  cities: [],
  interests: [],
  ready: false,
};
